// Official GharSetGo logo assets (uploaded May 2026 — replaces older "kvhkervg" variant).
// LOGO_URL  → square app icon (used for favicon, header avatars, OG image, push icons).
// LOGO_FULL → wordmark with the घर glyph (suitable for landing hero / auth screens).
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_3cfbfaa3-6b26-4d2c-bbad-bcc8c90ef543/artifacts/gudsns5v_gharsetgo-appicon-final.png';
export const LOGO_FULL = 'https://customer-assets.emergentagent.com/job_3cfbfaa3-6b26-4d2c-bbad-bcc8c90ef543/artifacts/fbry369a_gharsetgo-logo-final.png';

export default function Logo({ size = 32, className = '', alt = 'GharSetGo', variant = 'icon' }) {
  if (variant === 'full') {
    // Full wordmark — let height drive the size, width auto-scales by aspect ratio.
    return <img src={LOGO_FULL} alt={alt} style={{ height: size, width: 'auto' }} className={className} loading="lazy" />;
  }
  return <img src={LOGO_URL} alt={alt} width={size} height={size} className={className} loading="lazy" />;
}
